import { render, staticRenderFns } from "./ReturnInspectionModal.vue?vue&type=template&id=6ec9a15a"
import script from "./ReturnInspectionModal.vue?vue&type=script&lang=js"
export * from "./ReturnInspectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports